import * as React from "react"
import { List } from "immutable";
import { pushTag } from "./datalayer";

export type QuickLinksProps = {
  className?: string
  title: string
  links: List<QuickLink>
  handleScroll: (slug: string) => void
}

export type QuickLink = {
  title: string,
  url: string
}

export const QuickLinks = (p: QuickLinksProps): JSX.Element => (
  <nav className={`quicklinks ${p.className ? p.className : ""}`} aria-label="Snelkoppelingen">
    <p className="quicklinks__title">{p.title}</p>

    <ul className="quicklinks__list">
      {p.links.map((c, i) => (
        <li key={`group-scroll-${i}`} className="quicklink">
          <div className="quicklink__inner">
            <a
              href=""
              className="button button--tertiary quicklink__link"
              onClick={e => {
                e.preventDefault()
                pushTag(c.title)
                p.handleScroll(c.url)
              }}
            >
              {c.title}
            </a>
          </div>
        </li>
      ))}
    </ul>
  </nav>
)

{/* TH: Added to styleguide! */}
